export default __webpack_public_path__ + "static/media/StorageContainerMk2.256.186f69b7.png";